import { render, staticRenderFns } from "./deliverySettlementManage.vue?vue&type=template&id=f2319dd4&scoped=true"
import script from "./deliverySettlementManage.vue?vue&type=script&lang=js"
export * from "./deliverySettlementManage.vue?vue&type=script&lang=js"
import style0 from "./deliverySettlementManage.vue?vue&type=style&index=0&id=f2319dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2319dd4",
  null
  
)

export default component.exports